import React from 'react';
import foto1 from '../images/foto1.jpg';
import foto2 from '../images/foto2.jpg';
import foto3 from '../images/foto3.jpg';

const LandingPage = () => {

  
  return (
    <div className="landing-container">
      <h1>Bienvenido a MDT</h1>
      <p>Aplicación de Transcripción Médica para la Creación Automatizada de diferentes Registros Medicos</p>
    <div className='content-wrapper-header2'>
        <div className='content-wrapper-context'>
            <div className='content-wrapper-text'>
                <h1>Dicta y Transcribe</h1>
                    <p>Los médicos pueden dictar fácilmente el texto que desean registrar. MDT transcribe y formatea el texto para obtener registros claros y precisos.</p>
            </div>
        </div>
        <img className='content-wrapper-img' src={foto1} alt="Example question 1 and answer" />
    </div>
    <div className='content-wrapper-header'>
    <img className='content-wrapper-img' src={foto2} alt="Example question 1 and ansswer" />
        <div className='content-wrapper-context'>
            <div className='content-wrapper-text'>
            <h1>Rápido y Eficiente</h1>
        <p>Automatiza el proceso de creación de registros quirúrgicos y ahorra tiempo valioso.</p>
            </div>
        </div>
        
    </div>
    <div className="content-wrapper-header">
  <div className="content-wrapper-context">
    <div className="content-wrapper-text">
      <h1>Adaptado a la Experticia Médica</h1>
      <p>MDT está diseñado para comprender la terminología médica compleja en varias especialidades. Ya sea cirugía general, ortopedia o cardiología, nuestro sistema inteligente de transcripción se adapta a tu campo, garantizando precisión y claridad en cada registro.</p>
    </div>
  </div>
  <img className="content-wrapper-img" src={foto3} alt="Medical specialties illustration" />
</div>





 {/* New Features Section */}
 <div className="features-section">
        <h2>Características de MDT</h2>
        <ul>
        <li>Transcripción en tiempo real con alta precisión.</li>
<li>Capacidad de transcribir en múltiples idiomas manteniendo la precisión.</li>
<li>Extracción y análisis inteligente de información clave de las transcripciones.</li>
<li>Generación automática de registros basados en la información transcrita.</li>
<li>Presentación de registros en formatos profesionales y comprensibles.</li>
<li>Adaptabilidad para crear diferentes tipos de registros según las necesidades del usuario.</li>

        </ul>
      </div>

      {/* Testimonials Section */}
      <div className="testimonials-section">
        <h2>Lo que dicen nuestros usuarios</h2>
        <div className="testimonial-card">
          <p>"MDT ha revolucionado nuestro proceso de registro. ¡Es rápido, preciso y muy fácil de usar!"</p>
          <span>- Dr. Jane Doe, General Surgeon</span>
        </div>
        <div className="testimonial-card">
          <p>"La adaptabilidad de MDT a terminologías médicas especializadas es impresionante. ¡Altamente recomendado!"</p>
          <span>- Dr. John Smith, Cardiologist</span>
        </div>
      </div>

      {/* Call to Action */}
      <div className="cta-section">
        <h2>¿Listo para optimizar tu proceso de Registros médicos?</h2>
        <a href="https://wa.me/50246045383" target="_blank" rel="noopener noreferrer">
    <button className="cta-button"><h3>Solicita una prueba</h3></button>
</a>
      </div>


    
    </div>
  );
};

export default LandingPage;
